import Request from "../request";
const request = new Request();

export interface ICoupon {
  coupon_id: number;
  create_time: string;
  description: string;
  discount_value: number;
  grade: string;
  name: string;
  region_type: string;
  type: string;
  use_days: string;
  valid_days: number;
  valid_from: string;
  valid_to: string;
}

export interface ICouponHistory {
  coupon_history_id: number;
  coupon_name: string;
  name: string;
  email: string;
  create_time: string;
  use_time: string;
  expire_time: string;
  status: string;
  user_key: string;
}

export const COUPON_HISTORY_STATUS = {
  A: "사용가능",
  B: "사용완료",
};

export const COUPON_TYPE = {
  A: "이용권",
  B: "할인권",
};

export const REGION_TYPE = {
  A: "전국",
  B: "서울/수도권",
  C: "지역구 통합",
  D: "대전/충청권",
  E: "강원도권",
  F: "경상권",
  G: "광주/전라권",
  H: "제주",
};

export const GRADE_TYPE = {
  S: "스타터",
  B: "베이직",
  P: "VIP",
};

export class CouponService {
  static couponList = async (
    limit: number,
    page: number
  ): Promise<{ list: ICoupon[]; totalCount: number }> => {
    const { data: res } = await request.get(`coupon?limit=${limit}&page=${page}`);

    return res.data;
  };

  static couponHistory = async (
    search: string,
    couponId: number,
    isUsed: string,
    issueDateSort: string,
    expirationDateSort: string,
    limit: number,
    page: number
  ): Promise<{ list: ICouponHistory[]; totalCount: number }> => {
    const params = new URLSearchParams();
    params.append("limit", limit.toString());
    params.append("page", page.toString());
    params.append("search", search);
    params.append("couponId", couponId.toString());
    params.append("isUsed", isUsed);
    params.append("issueDateSort", issueDateSort);
    params.append("expirationDateSort", expirationDateSort);

    const { data: res } = await request.get(`coupon/history?${params.toString()}`);

    return res.data;
  };

  static issueCoupon = async (couponIdx: number, userList: any[]) => {
    const { data: res } = await request.post(`coupon/${couponIdx}`, { userList });

    return res.data;
  };
}
